import React from 'react';
import PropTypes from 'prop-types';

import BaseComponent from '../../../baseClasses/BaseComponent';
import TableRowCell from './TableRowCell';
import CheckBox from '../../CheckBox';
import DataSource from '../../../dao/DataSource/DataSource';

import './TableRow.scss';

class TableRow extends BaseComponent {

  constructor(props) {
    super(props);
    
    this.state = {
      isSelected: this.props.isSelected ||false,
    };
    this.types = {
      'reference-documents': ['name', 'extension', 'full_name', 'date_time', 'markets', 'tasks_count', 'version_count', 'delete'],
      'project-report': ['location_id', 'contract_id', 'project_name', 'site_name', 'address', 'project_type', 'project_manager', 'created_at', 'status'],
      user: ['first_name', 'last_name', 'company_name', 'projects', 'active_total_tasks'],
      'activity-log': ['name', 'sub_type', 'first_name', 'last_name', 'date_time', 'company_name', 'description'],
      inventory: ['identifier', 'name', 'user', 'created_at', 'tasks'],
      template: ['name', 'guid', 'status', 'last_template_version'], // return if needed 'assigned'
      closeout: ['name', 'closeoutable_type', 'type', 'project_name', 'user_name', 'project_type_name', 'status', 'project_manager_name', 'created_at'],
      users: ['first_name', 'last_name', 'phone', 'email', 'company_name', 'role', 'markets', 'options'],
      team: ['name', 'lead_user', 'projects_active', 'members', 'markets', 'options'],
      attachment: ['name', 'closeoutable_type', 'type', 'user', 'created_at'],
    };
    if (this.props.types && this.props.type) {
      this.types[this.props.type] = this.props.types;
    }

    this.handleSelection = this.handleSelection.bind(this);
    this.checkToggled = this.checkToggled.bind(this);
  }

  componentDidMount() {
    if (this.props.dataSourceName) {
      this.dataSource = new DataSource(this.props.dataSourceName, this.props.selectedItem.id, this.props.recordDescriptor);
      this.dataSource.get();
    }
    const selectedItem = this.props.selectedItem;
    selectedItem.projects_active = selectedItem.active_projects_count + ' | ' + selectedItem.total_projects_count;
    this.setState({ selectedItem });
  }

  componentDidUpdate(prevProps) {
    if (this.props.isSelected != prevProps.isSelected) {
      this.setState({ isSelected: this.props.isSelected });
    }
    else if (this.props.selectedItem != prevProps.selectedItem) {
      // set active and total count
      this.props.selectedItem.projects_active = this.props.selectedItem.active_projects_count + ' | ' + this.props.selectedItem.total_projects_count;
      this.setState({ selectedItem: this.props.selectedItem });
    }
  }

  componentWillUnmount() {
    if (this.dataSource) {
      this.dataSource.release();
      this.dataSource = null;
    }
  }

  handleSelection(isSelected) {
    const { select, checked } = this.props;
    const { selectedItem } = this.state;
    if (!checked || checked == select) {
      this.setState({ isSelected });
    }
    if (selectedItem && select) {
      if (checked && checked != select) {
        isSelected = this.state.isSelected;
      }
      select(selectedItem, isSelected);
    }
  }

  checkToggled(isSelected, item, e) {
    const { selectedItem } = this.state;
    const { checked, select } = this.props;
    if (checked) {
      if (checked != select) {
        // checked callback exists so stop propagation (to prevent select)
        e.stopPropagation();
      }
      checked(selectedItem, isSelected, this.props.parentItem);
    }
    this.setState({ isSelected });
  }

  handleTypeDisplay() {
    const { type } = this.props;
    const { selectedItem } = this.state;
    const { accent, optionsHandler, deleteHandler } = this.props;

    // Status mapping for custom display
    const statusMap = {
      in_progress: 'In Progress',
      not_started: 'Not Started',
      completed: 'Completed',
    };

    return this.types[type].map((cellType, i) => {
      let cellValue = selectedItem[cellType];
      // If the cell is 'status', map it to a display string
      if (cellType === 'status' && cellValue && statusMap[cellValue]) {
        cellValue = statusMap[cellValue];
      }
      // Show last version as e.g. 'Version 1'
      if (cellType === 'last_template_version' && cellValue) {
        cellValue = `Version ${cellValue}`;
      } 
      return (
        <TableRowCell
          key={i}
          type={type}
          cellType={cellType}
          selectedItem={{ ...selectedItem, [cellType]: cellValue }}
          accent={accent}
          isVendorUser={this.props.isVendorUser}
          optionsHandler={optionsHandler}
          deleteHandler={deleteHandler}
          currentCompany={this.props.currentCompany}
        />
      );
    });
  }

  render() {
    const { isSelected } = this.state;
    const { even, type, hasCheckBox, hasNarrowCheckBox, rowSelected, disabled } = this.props;
    const { selectedItem } = this.state;
    if (!selectedItem) {
      return null;
    }
    
    const suspend = selectedItem && selectedItem.suspended ? ' suspended' : '';
    const notClickable = this.props.notClickable || disabled ? ' not-clickable' : '';
    const evenClass = (rowSelected ? ' row-selected' : even ? ' even' : '');
    const checkBoxClass = hasNarrowCheckBox ? ' has-checkbox has-narrow-checkbox' : hasCheckBox ? ' has-checkbox' : '';
    const disabledClass = disabled ? ' row-disabled' : '';

    const noHover = type == 'inventory' || type == 'team' ? 'noHover' : '';

    return (
      <div
        className={'TableRow' + suspend + evenClass + checkBoxClass + notClickable + disabledClass}
        id={noHover}
        onClick={disabled ? undefined : () => this.handleSelection(!isSelected)}
        style={disabled ? { pointerEvents: 'none' } : {}}
      >
        {(hasCheckBox || hasNarrowCheckBox) && (
          disabled ? (
            // Fake checkbox for indentation, styled as disabled
            <span className="fake-checkbox disabled-checkbox" />
          ) : (
            <CheckBox checked={isSelected} toggleCheckBox={this.checkToggled} />
          )
        )}
        {this.handleTypeDisplay()}
      </div>
    );
  }
}

export default TableRow;

TableRow.propTypes = {
  selectedItem: PropTypes.object.isRequired,
  even: PropTypes.bool.isRequired,
  select: PropTypes.func,
  accent: PropTypes.string,
  hasCheckBox: PropTypes.bool,
  hasNarrowCheckBox: PropTypes.bool,
  isVendorUser: PropTypes.bool,
  types: PropTypes.array,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Table/TableRow/index.js